<template>
    <header-layout :fo_config="fo_config" :settingsConfig="settingsConfig"></header-layout>
    <div class="login-content">
        <div class="containessr">
            <div class="row">
                <div class="col-lg-6">
                    <div class="image-login">
                        <img src="/assets/images/login.jpg" alt="">
                    </div>
                </div>
                <div class="col-lg-6 align-content-center">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
    <footer-layout :fo_content="fo_content"></footer-layout>
</template>

<script>
    import HeaderLayout from "../SharedComponents/Header.vue";
    import FooterLayout from "../SharedComponents/Footer.vue";
    export default {
        name : 'AuthLayout',
        components : {HeaderLayout, FooterLayout},
        props : ['fo_config', "settingsConfig", 'activeTab', 'fo_content'],
        methods: {
        }
    }
</script>